module.exports = __webpack_public_path__ + "c3e9f4d7480d81902924fea256ad7b6f.svg";